import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Image from "react-bootstrap/Image";

export const Footer = () => {
  return (
    <footer className="bg-dark text-light py-4">
      <Container>
        <Row>
          <Col lg={{ span: 2 }}>
            <h4>Contact</h4>
            <p>Email: mohamadtarabin@outlook.com</p>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <a href="https://www.linkedin.com/in/mohamad-tarabin-aa19471b8">
                <Image
                  src="images/icons/linkedin.png"
                  width="40px"
                  height="40px"
                />
              </a>
              <a href="https://www.researchgate.net/profile/Mohamad-Tarabin">
                <Image
                  src="images/icons/Research Gate Logo.webp"
                  width="40px"
                  height="40px"
                />
              </a>
              <a href="https://scholar.google.com/citations?user=-xaanw0AAAAJ&hl=en">
                <Image
                  src="images/icons/Google Scholar Rectangle.png"
                  width="40px"
                  height="40px"
                />
              </a>
            </div>
            {/* <p>Phone: 123-456-7890</p> */}
          </Col>
        </Row>
        <hr className="bg-light" />
        <p className="text-center">
          &copy; {new Date().getFullYear()} Mohamad Tarabin. All rights reserved.
        </p>
      </Container>
    </footer>
  );
};
